import { useApiService } from "medere-ui-framework";
import { AccountDTO, AccountMovementListDTO } from "../../dto/CurrentAccountDTO";

export function useCurrentAccountService() {
  const { api, getMethod } = useApiService();
  const baseEndpoint = "/api/secured/currentaccount";

  function getAccounts(offSet: number, pageSize: number, params?: any): Promise<AccountDTO[]> {
    return getMethod<AccountDTO[]>({
      basePath: baseEndpoint,
      endpoint: "/getAccounts",
      params: {
        offset: offSet,
        pageSize,
        fromEntityName: params?.fromEntityName || undefined,
        toEntityName: params?.toEntityName || undefined,
        balanceType: params?.balanceType || undefined,
      },
    });
  }

  function getAccountMovements(offSet: number, pageSize: number, params?: any): Promise<AccountMovementListDTO[]> {
    return getMethod<AccountMovementListDTO[]>({
      basePath: baseEndpoint,
      endpoint: "/getAccountMovements",
      params: {
        accountId: params?.accountId,
        offset: offSet,
        pageSize,
      },
    });
  }

  function getMovementDetail(accountMovementId: number) {
    return getMethod({
      basePath: baseEndpoint,
      endpoint: "/getMovementDetail",
      params: { accountMovementId },
    });
  }

  function getMovementAttachments(accountMovementId: number) {
    return getMethod({
      basePath: baseEndpoint,
      endpoint: "/getMovementAttachments",
      params: { accountMovementId },
    });
  }

  function uploadMovementAttachment(accountMovementId: number, file: File) {
    const formData = new FormData();
    formData.append("file", file);
    return api.post(`${baseEndpoint}/uploadMovementAttachment`, formData, {
      params: { accountMovementId },
      headers: { "Content-Type": "multipart/form-data" },
    }).then(r => r.data);
  }

  return {
    getAccounts,
    getAccountMovements,
    getMovementDetail,
    getMovementAttachments,
    uploadMovementAttachment,
  };
}
